import styled from 'styled-components';
import theme from '~/styling/theme';

export const Wrapper = styled.div`
  font-family: var(--font-primary);
`;

export const Title = styled.h2`
  padding-bottom: 5rem;
  text-align: center;
  font-size: 32px;
  font-weight: 400;
  line-height: 1.2;
  font-family: var(--font-tertiary);
  @media (${theme.respondTo.tablet}) {
    font-size: 38px;
    line-height: 1.4;
  }
`;
